import { supabase } from '@/core/database/supabase';
import type { ConstructionBoqVersion } from '../types/construction-boq.types';

export const ConstructionBoqVersionsService = {
  async getBoqVersions(boqId: string) {
    const { data, error } = await supabase
      .from('construction_boq_versions')
      .select(`
        *,
        project:projects(id, name),
        boq:construction_boqs(id, boq_name)
      `)
      .eq('boq_id', boqId)
      .order('version_number', { ascending: false });

    if (error) throw error;
    return data as ConstructionBoqVersion[];
  },

  async createBoqVersion(data: Partial<ConstructionBoqVersion>) {
    const { data: result, error } = await supabase
      .from('construction_boq_versions')
      .insert([data])
      .select()
      .single();

    if (error) throw error;
    return result as ConstructionBoqVersion;
  }
};
